import { render, staticRenderFns } from "./news-banner.vue?vue&type=template&id=30068b00&scoped=true&lang=pug&"
import script from "./news-banner.vue?vue&type=script&lang=js&"
export * from "./news-banner.vue?vue&type=script&lang=js&"
import style0 from "./news-banner.vue?vue&type=style&index=0&id=30068b00&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30068b00",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NewsroomAvatar: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/newsroom/avatar.vue').default,NewsroomCard: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/newsroom/card.vue').default})
